<template>
  <category-page
    :resource-params="resourceParams"
    :available-filters="availableFilters"
    :parent="parent"
    subtitle="Teaching ideas & inspiration"
  />
</template>

<script>
/* Blog Category Listing Page
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

import CategoryPage from '~/components/category/CategoryPage.vue';

const root = 'category';

export default {
  name: 'BlogCategory',
  components: {
    CategoryPage,
  },
  async asyncData({ app, store, route, params, error }) {
    const data = {};

    // For the resource list query
    data.resourceParams = {
      country: app.i18n.locale,
      category: params.slug,
      orderBy: 'created',
      perPage: 32,
      types: ['blog'],
      root,
    };

    try {
      // Load the category
      const category = await store.dispatch('loadCategory', {
        category: params.slug,
        root,
        link: route.path,
      });

      // For meta fields
      data.title = category.name + ' Blog Posts | The Chalkboard';
      data.category = category;
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title: 'The Chalkboard',
      category: {},
      resourceParams: {},
      availableFilters: null,
      parent: { name: 'Blog', path: '/' + this.$i18n.locale + '/teaching-blog/' },
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: this.$metaPropertiesCategory(this.category),
      link: this.$hrefLangsPage(this.$route),
    };
  },
};
</script>
